import { alpha } from '@mui/material/styles';

import {THEME_MODE} from "../../@constants";


// SETUP COLORS
const GREY = {
  0: '#fff',
  100: '#f9fafb',
  200: '#f4f6f8',
  300: '#dadce0',
  400: '#c4cdd5',
  500: '#919eab',
  600: '#637381',
  700: '#454f5b',
  800: '#212b36',
  900: '#161c24'
};

const PRIMARY = {
  lighter: '#beaeee',
  light: '#a38ee7',
  main: '#7c5ddd',
  dark: '#694bd4',
  darker: '#4c30c7',
  contrastText: GREY[100]
};

const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#84A9FF',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A',
  contrastText: GREY[100],
};

const INFO = {
  lighter: '#d0f2ff',
  light: '#74caff',
  main: '#1890ff',
  dark: '#0c53b7',
  darker: '#04297a',
  contrastText: GREY[100]
};

const SUCCESS = {
  lighter: '#def3eb',
  light: '#aaf27f',
  main: '#54d62c',
  dark: '#229a16',
  darker: '#08660d',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#fff7cd',
  light: '#ffe16a',
  main: '#ffc107',
  dark: '#b78103',
  darker: '#7a4f01',
  contrastText: GREY[800]
};

const ERROR = {
  lighter: '#ffe7d9',
  light: '#ffa48d',
  main: '#ff4842',
  dark: '#b72136',
  darker: '#7a0c2e',
  contrastText: GREY[100],
};

const COMMON = {
  common: { black: '#000000', white: '#FFFFFF' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
}


export const minimalPaletteLight = {
  mode: THEME_MODE.LIGHT,
  ...COMMON,
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
    contrastText: GREY[100],
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[300],
    black: GREY[800]
  },
  action: {
    ...COMMON.action,
    active: GREY[600],
  },
}

export const minimalPalleteDark = {
  mode: THEME_MODE.DARK,
  ...COMMON,
  text: {
    primary: '#fff',
    secondary: GREY[500],
    disabled: GREY[600],
    contrastText: GREY[800],
  },
  background: {
    paper: GREY[800],
    default: GREY[900],
    neutral: alpha(GREY[500], 0.16),
    white: "#fff"
  },
  action: {
    ...COMMON.action,
    active: GREY[500]
  }
}